import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const HtmlEditorMobile: React.FC = () => (
  <SEOLandingPage
    title="HTML Editor for Mobile — View & Edit HTML on Android | Cosmovex"
    metaDescription="HTML Viewer And Editor for Android. Open and edit HTML files on your phone, preview them in a real browser view, and share or export the result."
    ogTitle="HTML Editor for Mobile — HTML Viewer And Editor"
    h1="HTML Editor for Mobile"
    intro="Open any HTML file on your Android phone, edit it with syntax highlighting, and see how it renders — instantly. HTML Viewer And Editor is built for mobile-first HTML work."
    paragraphs={[
      "HTML files are everywhere — email templates, static pages, documentation, UI prototypes. HTML Viewer And Editor lets you open them on Android, read the code with proper syntax highlighting, make edits, and see the result in a built-in browser preview. No laptop, no desktop browser required.",
      "The editor is built for HTML specifically. Tags are color-coded, attribute names are highlighted differently from attribute values, and indentation is handled automatically. The editor understands HTML structure well enough to offer smart autocomplete for common tags and attributes, reducing the typing burden on a phone keyboard.",
      "The preview pane renders your HTML using the system WebView — the same engine that powers Chrome on Android. What you see in the preview is what any browser would render. CSS styles apply, JavaScript executes, images load from referenced URLs, and the layout reflects real browser behavior.",
      "HTML Viewer And Editor is particularly useful for people who receive HTML files as attachments — newsletters, templates, reports — and want to inspect or modify them without converting to a different format. You can open the file, clean up the code, and share the edited version directly from the app.",
    ]}
    features={[
      "HTML syntax highlighting with tag-aware coloring",
      "Real browser preview using WebView engine",
      "Split-pane editor and preview mode",
      "Smart tag autocomplete and closing",
      "Open HTML files from storage or receive as attachment",
      "Edit and save to device",
      "Share HTML output or code",
      "Format and prettify HTML code",
      "Find and replace within the file",
      "Works offline — no internet needed for local HTML",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.htmlvedit"
    icon="/images/htmlvedit.png"
    appName="HTML Viewer And Editor"
    accentColor="#A8720E"
    canonicalPath="/html-editor-mobile"
  />
);

export default HtmlEditorMobile;
